<template>
  <div class="ticket-form-input-container row">
    <div
      v-for="(input, index) in inputs"
      :key="index"
      :class="getInputContainerClassname(input.name)"
    >
      <div v-if="input.name === 'sectionLabel'" class="section-label col-12">
        {{ input.text }}
      </div>
      <textInput
        v-if="getInputType(input.name) === 'textInput'"
        :labelKey="getInputLabel(input.name)"
        :inputId="input.name"
        :pattern="getPattern(input.name)"
        :errorLabelKey="getErrorKeyLabel(input.name)"
        :maxlength="getInputMaxLength(input.name)"
        :required="input.required"
        :ref="input.name"
        :linkedToOtherInput="getLinkedToOtherInput(input.name)"
        :type="getInputTextType(input.name)"
        @textInput-changed="onTextInputChange"
      />

      <textArea
        v-if="getInputType(input.name) === 'textArea'"
        :labelKey="getInputLabel(input.name)"
        :inputId="input.name"
        :pattern="getPattern(input.name)"
        :required="input.required"
        :ref="input.name"
        :defaultValue="input.defaultValue"
      >
        <template v-slot:subLabel>
          <div v-if="input.subLabelHtml" v-html="input.subLabelHtml"></div>
        </template>
      </textArea>

      <datePickerInput
        v-if="getInputType(input.name) === 'date'"
        :labelKey="getInputLabel(input.name)"
        :inputId="input.name"
        :required="input.required"
        :ref="input.name"
        :modelType="getNameToDateModelType(input.name)"
      ></datePickerInput>

      <selectInput
        v-if="getInputType(input.name) === 'select'"
        :defaultOptions="getSelectOption(input.name)"
        :labelKey="getInputLabel(input.name)"
        :inputId="input.name"
        :required="input.required"
        :errorMessageKey="input.name + '-error'"
        :ref="input.name"
      ></selectInput>

      <multiSelectInput
        v-if="getInputType(input.name) === 'multiselect'"
        :defaultOptions="getSelectOption(input.name)"
        :labelKey="getInputLabel(input.name)"
        :inputId="input.name"
        :required="input.required"
        :errorMessageKey="input.name + '-error'"
        :ref="input.name"
      ></multiSelectInput>

      <pecOrPeo
        v-if="getInputType(input.name) === 'pec_peo_switch'"
        :labelKey="getInputLabel(input.name)"
        :inputId="input.name"
        :required="input.required"
        :patternEmail="getPattern('email')"
        :patternPec="getPattern('pec')"
        :ref="input.name"
      ></pecOrPeo>

      <iban
        v-if="getInputType(input.name) === 'iban'"
        :inputId="input.name"
        :showIban="input.showIban"
        :showIntestatario="input.showIntestatario"
        :showBicswift="input.showBicswift"
        :ibanRequired="input.ibanRequired"
        :intestatarioRequired="input.intestatarioRequired"
        :ref="input.name"
      ></iban>
    </div>
  </div>
</template>

<script>
import intl from "./intl/intl";
import {
  nameToInputType,
  nameToInputPattern,
  nameToSelectOptions,
  nameToInputTextMaxLength,
  nameToInputTextType,
  nameToDateModelType,
  nameToInputLabel,
  nameToErrorKeyLabel,
  nameToLinkedToOtherInput,
  nameToContainerInputClassname
} from "./utils";
import TextInput from "../formInputs/textInput/TextInput.vue";
import TextArea from "../formInputs/textArea/TextArea.vue";
import DatePickerInput from "../formInputs/datePickerInput/DatePickerInput.vue";
import SelectInput from "../formInputs/selectInput/SelectInput.vue";
import MultiSelectInput from "../formInputs/multiSelectInput/MultiSelectInput.vue";
import PecOrPeo from "../formInputs/pecPeoEmail/PecOrPeo.vue";
import Iban from "../formInputs/iban/Iban.vue";
export default {
  name: "ticketFormInputs",
  components: {
    textInput: TextInput,
    textArea: TextArea,
    datePickerInput: DatePickerInput,
    selectInput: SelectInput,
    multiSelectInput: MultiSelectInput,
    pecOrPeo: PecOrPeo,
    iban: Iban,
  },

  props: {
    answerId: {
      type: Number,
      default: null,
    },
    pattern: {
      type: String,
      default: null,
    },
    answerDetail: {
      type: Object,
      default: null,
    },
  },
  mounted() {},
  beforeUnmount() {},
  data: function () {
    return {
      intl: intl,
      submitFormEffettuato: false,
      // inputs: this.answerDetail && this.answerDetail.answerShowInput ? this.answerDetail.answerShowInput : []
    };
  },
  methods: {
    onTextInputChange(value, inputId) {
      switch (inputId) {
        case "telefon":
        case "mobile":
          if (this.submitFormEffettuato) {
            this.numeriDiTelefonoOk();
          }
          break;
        case "piva":
        case "codfisc":
          if (
            this.submitFormEffettuato &&
            this.area ==
              this.$store.state["libraryWiperConfig"].ufficioAmministrativoId
          ) {
            this.pivaCodfiscOk();
          }
          break;
        case "name":
        case "surname":
        case "ragione_sociale":
          if (
            this.area ==
              this.$store.state["libraryWiperConfig"].ufficioAmministrativoId &&
            this.submitFormEffettuato
          ) {
            this.nameSurnameRagionesocialeOk();
          }
        default:
          return;
          break;
      }
    },

    checkFormInputsMessages() {
      this.inputs.map((input) => {
        if (
          this.$refs[input.name] &&
          this.$refs[input.name]["0"] &&
          this.$refs[input.name]["0"].checkMessage
        ) {
          this.$refs[input.name]["0"].checkMessage();
        }
      });
    },

    /**
     * Metodo che ritorna il payload per la creazione del ticket.
     *
     * @returns {boolean} Tutti gli input obbligatori sono compilati correttamente.
     * @description Questo metodo viene usato per stabilire se ogni input della form sia correttamente compilato
     *              Ogni componente che rappresenta un elemento della form deve avere il suo metodo requiredInputIsOk.
     */
    inputOblligatoriOk() {
      let inputOk = true;
      this.submitFormEffettuato = true;
      let checkTelefon = false;
      let checkPivaCodFisc = false;
      let checkNamesurnameRagionesociale = false;
      this.inputs.map((input) => {
        if (
          this.area ==
          this.$store.state["libraryWiperConfig"].ufficioAmministrativoId
        ) {
          if (
            input.name !== "piva" &&
            input.name !== "codfisc" &&
            input.name !== "ragione_sociale" &&
            input.name !== "name" &&
            input.name !== "surname"
          ) {
            if (
              this.$refs[input.name] &&
              this.$refs[input.name]["0"] &&
              !this.$refs[input.name]["0"].requiredInputIsOk()
            ) {
              inputOk = false;
            }
          }
          if (input.name === "piva" || input.name === "codfics") {
            checkPivaCodFisc = true;
          }
          if (
            input.name === "ragione_sociale" ||
            input.name === "name" ||
            input.name === "surname"
          ) {
            checkNamesurnameRagionesociale = true;
          }
        } else {
          if (input.name !== "telefon" && input.name !== "mobile") {
            if (
              this.$refs[input.name] &&
              this.$refs[input.name]["0"] &&
              !this.$refs[input.name]["0"].requiredInputIsOk()
            ) {
              inputOk = false;
            }
          }
          if (input.name === "telefon" || input.name === "mobile") {
            checkTelefon = true;
          }
        }
      });

      let telefonoOk = true;
      let pivaCodfiscOk = true;
      let nameSurnameRagionesocialeOk = true;
      if (checkPivaCodFisc) {
        pivaCodfiscOk = this.pivaCodfiscOk();
      }
      if (checkTelefon) {
        telefonoOk = this.numeriDiTelefonoOk();
      }
      if (checkNamesurnameRagionesociale) {
        nameSurnameRagionesocialeOk = this.nameSurnameRagionesocialeOk();
      }
      if (inputOk) {
        inputOk =
          inputOk && telefonoOk && pivaCodfiscOk && nameSurnameRagionesocialeOk;
      }
      return inputOk;
    },

    pivaCodfiscOk() {
      let codfisc = "";
      let piva = "";
      //nel caso in cui nel form ci sono entrambe ne basta una
      if (this.$refs["codfisc"] && this.$refs["piva"]) {
        codfisc = this.$refs["codfisc"]["0"].inputField;
        piva = this.$refs["piva"]["0"].inputField;
        if (codfisc.length === 0 && piva.length === 0) {
          this.$refs["piva"]["0"].setCustomErrorLabelKey("");
          this.$refs["piva"]["0"].setRequired(true);
          this.$refs["codfisc"]["0"].setRequired(true);
          return (
            this.$refs["piva"]["0"].requiredInputIsOk() &&
            this.$refs["codfisc"]["0"].requiredInputIsOk()
          );
        } else if (!this.$refs["piva"]["0"].isNumber()) {
          this.$refs["piva"]["0"].setRequired(true);
          this.$refs["codfisc"]["0"].setRequired(true);
          this.$refs["piva"]["0"].setCustomErrorLabelKey(
            "piva-field-not-ok-number"
          );
          this.$refs["codfisc"]["0"].setCustomErrorLabelKey(
            "piva-field-not-ok-number"
          );
          return (
            this.$refs["piva"]["0"].requiredInputIsOk() &&
            this.$refs["codfisc"]["0"].requiredInputIsOk()
          );
        } else {
          this.$refs["piva"]["0"].setCustomErrorLabelKey("");
          this.$refs["codfisc"]["0"].setCustomErrorLabelKey("");
          this.$refs["piva"]["0"].setRequired(false);
          this.$refs["codfisc"]["0"].setRequired(false);
          return (
            this.$refs["piva"]["0"].requiredInputIsOk() &&
            this.$refs["codfisc"]["0"].requiredInputIsOk()
          );
        }
      } else if (this.$refs["codfisc"]) {
        if (
          this.$refs["codfisc"] &&
          this.$refs["codfisc"]["0"] &&
          !this.$refs["codfisc"]["0"].requiredInputIsOk()
        ) {
          return false;
        } else {
          return true;
        }
      } else if (this.$refs["piva"]) {
        if (
          this.$refs["piva"] &&
          this.$refs["piva"]["0"] &&
          !this.$refs["piva"]["0"].requiredInputIsOk()
        ) {
          return false;
        } else {
          return true;
        }
      }
      return true;
    },

    numeriDiTelefonoOk() {
      if (this.$refs["mobile"] && this.$refs["telefon"]) {
        if (
          (this.$refs["telefon"]["0"].inputField &&
            this.$refs["telefon"]["0"].isNumber()) ||
          (this.$refs["mobile"]["0"].inputField &&
            this.$refs["mobile"]["0"].isNumber())
        ) {
          this.$refs["telefon"]["0"].setRequired(false);
          this.$refs["mobile"]["0"].setRequired(false);
          return (
            this.$refs["telefon"]["0"].requiredInputIsOk() &&
            this.$refs["mobile"]["0"].requiredInputIsOk()
          );
        } else {
          this.$refs["telefon"]["0"].setRequired(true);
          this.$refs["mobile"]["0"].setRequired(true);
          return (
            this.$refs["telefon"]["0"].requiredInputIsOk() &&
            this.$refs["mobile"]["0"].requiredInputIsOk()
          );
        }
      }
      return true;
    },

    nameSurnameRagionesocialeOk() {
      if (
        this.$refs["name"] &&
        this.$refs["surname"] &&
        this.$refs["ragione_sociale"]
      ) {
        if (this.$refs["ragione_sociale"]["0"].inputField.length > 0) {
          this.$refs["name"]["0"].setRequired(false);
          this.$refs["surname"]["0"].setRequired(false);
          this.$refs["ragione_sociale"]["0"].setRequired(true);
        } else if (
          this.$refs["name"]["0"].inputField.length > 0 &&
          this.$refs["surname"]["0"].inputField.length > 0
        ) {
          this.$refs["name"]["0"].setRequired(true);
          this.$refs["surname"]["0"].setRequired(true);
          this.$refs["ragione_sociale"]["0"].setRequired(false);
        } else {
          this.$refs["name"]["0"].setRequired(true);
          this.$refs["surname"]["0"].setRequired(true);
          this.$refs["ragione_sociale"]["0"].setRequired(true);
        }
        return (
          this.$refs["name"]["0"].requiredInputIsOk() &&
          this.$refs["surname"]["0"].requiredInputIsOk() &&
          this.$refs["ragione_sociale"]["0"].requiredInputIsOk()
        );
      }
    },


    addSectionLabelsToInputs(inputs){
      if(this.area == this.$store.state["libraryWiperConfig"].ufficioAmministrativoId){
        const result = [];

        for (let i = 0; i < inputs.length; i++) {
          const obj = inputs[i];
          if (obj.name === 'name') {
            result.push({ name: 'sectionLabel', text: 'Almeno uno tra nome/cognome e ragione sociale' });
          }
          if (obj.name === 'codfisc') {
            result.push({ name: 'sectionLabel', text: 'Almeno uno tra codice fiscale e partita IVA' });
          }
          result.push(obj);
        }

        return result;

      }else{
        return inputs
      }
    },
    

    /**
     * Metodo che ritorna il payload per la creazione del ticket.
     *
     * @returns {object} Payload da inviare alla creazione del ticket.
     * @description QUESTO METODO SERVE PER PRENDERE I VALORI DELLE INPUT CHE COMPONGONO LA FORM.
     *              Ogni input del ticket deve salvare il suo valore in una variabile 'inputField'
     *              inputField puà essere un valore o un oggetto.
     *              Nel caso in cui sia un oggetto tutte le sue proprietà saranno copiate all'interno di params
     */
    getInputParams() {
      let params = {};
      this.inputs.map((input) => {
        if (this.$refs[input.name] && this.$refs[input.name]["0"]) {
          if (typeof this.$refs[input.name]["0"].inputField === "object") {
            params = { ...params, ...this.$refs[input.name]["0"].inputField };
          } else {
            params[input.name] = this.$refs[input.name]["0"].inputField;
          }
        }
      });
      return params;
    },
    getInputContainerClassname(name) {
      return nameToContainerInputClassname(name,this.area)
    },

    getInputType(name) {
      return nameToInputType(
        name,
        this.$store.state.libraryWiperConfig.questionarioId
      );
    },
    getPattern(name) {
      return nameToInputPattern(
        name,
        this.$store.state.libraryWiperConfig.questionarioId
      );
    },
    getInputMaxLength(name) {
      return nameToInputTextMaxLength(name);
    },
    getSelectOption(name) {
      return nameToSelectOptions(name);
    },
    getNameToDateModelType(name) {
      return nameToDateModelType(name);
    },
    getInputTextType(name) {
      return nameToInputTextType(name);
    },
    getInputLabel(name) {
      return nameToInputLabel(name, this.area);
    },
    getErrorKeyLabel(name) {
      return nameToErrorKeyLabel(name, this.area);
    },
    getLinkedToOtherInput(name) {
      return nameToLinkedToOtherInput(name, this.area);
    },
  },
  watch: {},
  computed: {
    area() {
      if (this.answerDetail?.answerAreaAsoc?.[0]) {
        return this.answerDetail.answerAreaAsoc[0].id_area;
      } else {
        return 2;
      }
    },
    inputs() {
      let formInputs = []
      if(this.answerDetail?.answerShowInput.length > 0){
        formInputs = this.answerDetail?.answerShowInput.filter(item => item.name !== 'active');
      }
      formInputs = this.addSectionLabelsToInputs(formInputs)
      return formInputs
    }
  },
};
</script>
